'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultReportDescription = ({
  isCustomerAnalysisEnabled
}) => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
  message: isCustomerAnalysisEnabled ? 'reporting-ui-components.reportDescription.customerAnalysisEnabledTooltip' : 'reporting-ui-components.reportDescription.customerAnalysisDisabledTooltip'
});